import React, { useContext } from 'react'
import { store } from '../../stores/multipost'
import { Button } from 'reactstrap'

export default function SubmitButton() {
  const { selectedAccounts, selectedFiles, messages, scheduled, submitting } = useContext(store)
  const accountLength = selectedAccounts.length
  const allEnabledActions = selectedFiles.flatMap(f => f.assets.flatMap(a => a.enabledActions))
  const uniqueEnabledActions = Object.values(allEnabledActions.reduce((actions, action) => {
    if(selectedAccounts.includes(action.provider)) {
      actions[action.key] = action
    }
    return actions
  }, {}))

  let postCount = 0
  let displayAccountLength = 0

  if(uniqueEnabledActions.length === 0){
    if(messages.default.value.length > 0) {
      postCount = selectedAccounts.filter(a => a !== 'instagram').length
      displayAccountLength = selectedAccounts.filter(a => a !== 'instagram').length
    } else {
      postCount = selectedAccounts.filter(a => a !== 'instagram' && a !== 'default' && messages[a].value.length > 0).length
      displayAccountLength = selectedAccounts.filter(a => a !== 'instagram' && a !== 'default' && messages[a].value.length > 0).length
    }
  } else {
    postCount = uniqueEnabledActions.length
    displayAccountLength = uniqueEnabledActions.reduce((accounts, action) => {
      if(!accounts.includes(action.provider)) {
        accounts.push(action.provider)
      }
      return accounts
    }, []).filter(a => selectedAccounts.includes(a)).length
  }

  const disabled =
    postCount === 0 ||
    accountLength === 0 ||
    (selectedFiles.length === 0 && (Object.values(messages).some(m => m.overLength) || !Object.values(messages).some(m => m.value.length))) ||
    (selectedFiles.length === 0 && messages.instagram.value.length > 0 && selectedAccounts.includes('instagram') && Object.entries(messages).filter(([provider, message]) => provider !== 'instagram').every(([_, message]) => message.value.length === 0)) ||
    (uniqueEnabledActions.every(a => a.provider === 'instagram' && !a.story) && messages.instagram.value.length > 0)

  let content
  if(accountLength === 0) {
    content = "Select at least one account"
  } else if (postCount === 0) {
    content = "Select a file or add a message"
  } else {
    content = [scheduled ? 'Schedule' : 'Send', postCount, (postCount === 1 ? 'Post' : 'Posts'), 'to', displayAccountLength, (displayAccountLength === 1 ? 'Account' : 'Accounts')].join(' ')
  }

  return (
    <Button color="primary" size="lg" className="w-100 mb-4" type="submit" disabled={disabled || submitting}>
      {content}
    </Button>
  )
}